import { defineComponent as Z, openBlock as o, createElementBlock as e, mergeProps as p, unref as a, renderSlot as i, createElementVNode as l, createCommentVNode as u } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, g = { key: 1 }, M = { key: 2 }, f = { key: 3 }, H = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconToggleLeft"
}, b = /* @__PURE__ */ Z({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = h(s);
    return (m, t) => (o(), e("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      i(m.$slots, "default"),
      a(n) === "bold" ? (o(), e("g", A, t[0] || (t[0] = [
        l("path", { d: "M176,52H80a76,76,0,0,0,0,152h96a76,76,0,0,0,0-152Zm0,128H80A52,52,0,0,1,80,76h96a52,52,0,0,1,0,104ZM80,88a40,40,0,1,0,40,40A40,40,0,0,0,80,88Zm0,56a16,16,0,1,1,16-16A16,16,0,0,1,80,144Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (o(), e("g", g, t[1] || (t[1] = [
        l("path", {
          d: "M112,128A32,32,0,1,1,80,96,32,32,0,0,1,112,128Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,128H80A56,56,0,0,1,80,72h96a56,56,0,0,1,0,112ZM80,88a40,40,0,1,0,40,40A40,40,0,0,0,80,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,80,152Z" }, null, -1)
      ]))) : a(n) === "fill" ? (o(), e("g", M, t[2] || (t[2] = [
        l("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144ZM80,168a40,40,0,1,1,40-40A40,40,0,0,1,80,168Z" }, null, -1)
      ]))) : a(n) === "light" ? (o(), e("g", f, t[3] || (t[3] = [
        l("path", { d: "M176,58H80a70,70,0,0,0,0,140h96a70,70,0,0,0,0-140Zm0,128H80A58,58,0,0,1,80,70h96a58,58,0,0,1,0,116ZM80,90a38,38,0,1,0,38,38A38,38,0,0,0,80,90Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,80,154Z" }, null, -1)
      ]))) : a(n) === "regular" ? (o(), e("g", H, t[4] || (t[4] = [
        l("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,128H80A56,56,0,0,1,80,72h96a56,56,0,0,1,0,112ZM80,88a40,40,0,1,0,40,40A40,40,0,0,0,80,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,80,152Z" }, null, -1)
      ]))) : a(n) === "thin" ? (o(), e("g", k, t[5] || (t[5] = [
        l("path", { d: "M176,60H80a68,68,0,0,0,0,136h96a68,68,0,0,0,0-136Zm0,128H80A60,60,0,0,1,80,68h96a60,60,0,0,1,0,120ZM80,92a36,36,0,1,0,36,36A36,36,0,0,0,80,92Zm0,64a28,28,0,1,1,28-28A28,28,0,0,1,80,156Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  b as default
};
